import { useEffect, useState, useRef } from 'react';
import { SitesService } from 'src/services/sites/sites.service';

export interface AssignedForm {
  id: string;
  name: string;
  allowComments: boolean;
  isDefault: boolean;
}

export const useAssignedForms = (customerId?: string, siteId?: string) => {
  const [forms, setForms] = useState<AssignedForm[]>([]);
  const [loading, setLoading] = useState(true);
  const fetchedRef = useRef(false);

  useEffect(() => {
    if (!customerId || !siteId || fetchedRef.current) return;

    (async () => {
      try {
        const data = await SitesService.getAssignedForms(customerId, siteId);
        setForms(data);
      } catch (err) {
        console.error('Failed to fetch forms', err);
        setForms([]);
      } finally {
        setLoading(false);
        fetchedRef.current = true;
      }
    })();
  }, [customerId, siteId]);

  const hasForms = !loading && forms.length > 0;

  return { forms, loading, hasForms };
};
